import React, { Component } from "react";
import CartContext from "./CartContext";
import { SideMenu } from "./SideMenu"; // (left as-is, referenced by parent layouts)
import { BiRefresh } from "react-icons/bi";
import { BsFillPencilFill } from "react-icons/bs";
import { MessageBox } from "./MessageBox";
import { LoadSpinner } from "./LoadSpinner";
// import ReactDOM from "react-dom"; // not used
// import DatePicker from "react-date-picker"; // using native <input type="date"/>
import Select from "react-select";
import { Link } from "react-router-dom";
import { BlobServiceClient } from "@azure/storage-blob";
import Swal from "sweetalert2";
import Fuse from "fuse.js";
import RawMaterialsDashboard from "./RawmaterialsDashboard";
import {
  OverlayTrigger,
  ButtonGroup,
  Accordion,
  FloatingLabel,
  Stack,
  Tooltip,
  ListGroup,
  Badge,
  Button,
  ButtonToolbar,
  Form,
  FormControl,
  Row,
  Col,
  Modal,
  Nav,
  Tabs,
  Tab,
  Table,
  Navbar,
} from "react-bootstrap";

/* -------------------------------------------------------
   Utilities
--------------------------------------------------------*/
const asNumber = (v, fallback = 0) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : fallback;
};

/* =======================================================
   RawMaterialPurchaseOrders (Main)
======================================================= */
export class RawMaterialInward extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      rawmaterialpurchaseorders: [],
      rawmaterialwarehouse: [],
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      reload: true,
      rawmaterialsuppliers: [],
      prods: [],
      loaded: false,
      ShowPaidTabRefresh: false,
      ShowUnpaidTabRefresh: true,
      ShowPartiallyPaidTabRefresh: false,
      addModalShow: false,
      key: "UnPaidOrders",
      showAnalytics: false,
    };
    this._keyListener = this._keyListener.bind(this);
  }

  componentDidMount() {
    if (!this.state.loaded) {
      if (this.state.rawmaterialpurchaseorders.length === 0)
        this.GetRawMaterialPurchaseOrders();
      if (this.state.rawmaterialsuppliers.length === 0)
        this.GetRawMaterialSuppliers();
      this.GetRawMaterialsInventories();
      this.GetRawMaterialWarehouses();
      this.setState({ loaded: true });
    }
    window.scrollTo(0, 0);
    document.addEventListener("keydown", this._keyListener);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._keyListener);
  }

  _keyListener(e) {
    if (e.key === "F8") this.AddModalShow();
    else if (e.key === "F9") this.OnRefreshButtonClick();
  }

  /* ---------- Data Loads ---------- */
  GetRawMaterialsInventories = () => {
    this.setState({ prods: [] }, () => {
      fetch(
        `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsInventories/${this.context.storeId}`
      )
        .then((response) => response.json())
        .then((data) => {
          if (data?.status === 400) return;
          this.setState({ prods: data || [] }, () => {
            this.setState({ reload: false }, () =>
              this.setState({ reload: true })
            );
          });
        })
        .catch((error) =>
          console.error("GetRawMaterialsInventories error", error)
        );
    });
  };

  GetRawMaterialSuppliers = () => {
    fetch(
      `${process.env.REACT_APP_API}Supplier/GetSuppliers/${this.context.storeId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === 400) return;
        this.setState({ rawmaterialsuppliers: data || [] }, () => {
          this.setState({ reload: false }, () =>
            this.setState({ reload: true })
          );
        });
      })
      .catch((error) => console.error("GetSuppliers error", error));
  };

  GetRawMaterialWarehouses = () => {
    fetch(
      `${process.env.REACT_APP_API}Warehouse/GetRawMaterialWarehouses/${this.context.storeId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === 400) return;
        this.setState({ rawmaterialwarehouse: data || [] }, () => {
          this.setState({ reload: false }, () =>
            this.setState({ reload: true })
          );
        });
      })
      .catch((error) => console.error("GetRawMaterialWarehouses error", error));
  };

  GetRawMaterialPurchaseOrders = () => {
    fetch(
      `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialPurchaseOrders/${this.context.storeId}`
    )
      .then((response) => response.json())
      .then((data) => {
        if (data?.status === 400) return;
        this.setState({ rawmaterialpurchaseorders: data || [] }, () => {
          this.setState({ reload: false }, () =>
            this.setState({ reload: true })
          );
        });
      })
      .catch((error) =>
        console.error("GetRawMaterialPurchaseOrders error", error)
      );
  };

  /* ---------- UI helpers ---------- */
  CloseMessagBoxCallback = () => this.setState({ msgboxOpen: false });
  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });

  OnSaved = () => this.OnRefreshButtonClick();
  OnDeleted = () => this.OnRefreshButtonClick();

  OnRefreshButtonClick = () => {
    this.setState({ rawmaterialpurchaseorders: [] }, () => {
      this.GetRawMaterialPurchaseOrders();
      this.GetRawMaterialsInventories();
    });
  };

  addModalClose = () =>
    this.setState({ addModalShow: false }, this.OnRefreshButtonClick);
  AddModalShow = () => this.setState({ addModalShow: true });

  ShowSelectedTab = (k) => {
    this.setState({
      ShowPaidTabRefresh: false,
      ShowUnpaidTabRefresh: false,
      ShowPartiallyPaidTabRefresh: false,
    });
    if (k === "PaidOrders") this.setState({ ShowPaidTabRefresh: true });
    if (k === "UnPaidOrders") this.setState({ ShowUnpaidTabRefresh: true });
    if (k === "PartiallyPaidOrders")
      this.setState({ ShowPartiallyPaidTabRefresh: true });
  };

  render() {
    const orders = this.state.rawmaterialpurchaseorders || [];
    return (
      <>
        <div className="Container-fluid p-0 ">
          {this.state.msgboxOpen && (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          )}

          <Navbar className="shadow position-sticky fixed-top py-3 text-black ">
            <h4>RawMaterial Purchased INWARD&nbsp;</h4>
            <Navbar.Collapse className="justify-content-end mx-0 ">
              <Nav>
                <ButtonToolbar className="text-end align-middle">
                  <Button
                    size="sm"
                    className="mainthemecolor"
                    onClick={() => this.setState({ addModalShow: true })}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-plus"
                      viewBox="0 0 16 16"
                    >
                      <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
                    </svg>
                    &nbsp;Add (F8)
                  </Button>
                  &nbsp;
                  <Button
                    className="mainthemecolor"
                    size="sm"
                    onClick={this.OnRefreshButtonClick}
                  >
                    <BiRefresh size={16} /> &nbsp;Refresh (F9)
                  </Button>
                  &nbsp;
                  {/* ✅ Analytics button */}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => this.setState({ showAnalytics: true })}
                  >
                    📊 Analytics
                  </Button>
                  &nbsp;&nbsp;
                  {this.state.addModalShow && (
                    <RawMaterialPurchaseOrderAddOrEditModal
                      show={this.state.addModalShow}
                      Type="Add"
                      onHide={this.addModalClose}
                      rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                      prods={this.state.prods}
                      refresh={this.OnRefreshButtonClick}
                      GetRawMaterialsInventories={
                        this.GetRawMaterialsInventories
                      }
                      rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    />
                  )}
                </ButtonToolbar>
              </Nav>
            </Navbar.Collapse>
          </Navbar>

          <div className="purposestyle p-2 ">
            <b>Purpose:</b> Use this module to enter all "Purchased Rawmaterial
            Items" from a Supplier. Stocks will get adjusted upon creating new
            Purchase Order.
          </div>

          {orders.length > 0 && (
            <>
              <Tabs
                id="controlled-tab-example"
                activeKey={this.state.key}
                onSelect={(k) => {
                  this.setState({ key: k });
                  this.ShowSelectedTab(k);
                }}
                className="mb-3 bg-light fw-bold"
                fill
                style={{ fontSize: "16px" }}
              >
                <Tab
                  eventKey="UnPaidOrders"
                  title={`1. Unpaid Orders (${
                    orders.filter((f) => Number(f.paymentStatusId) === 2).length
                  })`}
                >
                  {this.state.ShowUnpaidTabRefresh && (
                    <RawMaterialPurchaseOrdersTable
                      status={2}
                      OnDeleted={this.OnDeleted}
                      rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                      rawmaterialpurchaseorders={orders}
                      prods={this.state.prods}
                      refresh={this.OnRefreshButtonClick}
                      rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                      GetRawMaterialsInventories={
                        this.GetRawMaterialsInventories
                      }
                    />
                  )}
                </Tab>

                <Tab
                  eventKey="PartiallyPaidOrders"
                  title={`2. Partially Paid Orders (${
                    orders.filter((f) => Number(f.paymentStatusId) === 3).length
                  })`}
                >
                  {this.state.ShowPartiallyPaidTabRefresh && (
                    <RawMaterialPurchaseOrdersTable
                      status={3}
                      OnDeleted={this.OnDeleted}
                      rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                      rawmaterialpurchaseorders={orders}
                      prods={this.state.prods}
                      refresh={this.OnRefreshButtonClick}
                      rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                      GetRawMaterialsInventories={
                        this.GetRawMaterialsInventories
                      }
                    />
                  )}
                </Tab>

                <Tab
                  eventKey="PaidOrders"
                  title={`3. Paid Orders (${
                    orders.filter((f) => Number(f.paymentStatusId) === 1).length
                  })`}
                >
                  {this.state.ShowPaidTabRefresh && (
                    <RawMaterialPurchaseOrdersTable
                      status={1}
                      OnDeleted={this.OnDeleted}
                      rawmaterialsuppliers={this.state.rawmaterialsuppliers}
                      rawmaterialpurchaseorders={orders}
                      prods={this.state.prods}
                      refresh={this.OnRefreshButtonClick}
                      GetRawMaterialsInventories={
                        this.GetRawMaterialsInventories
                      }
                      rawmaterialwarehouse={this.state.rawmaterialwarehouse}
                    />
                  )}
                </Tab>
              </Tabs>
            </>
          )}
          {/* ✅ Analytics Modal */}
          <Modal
            show={this.state.showAnalytics}
            onHide={() => this.setState({ showAnalytics: false })}
            size="xl"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Rawmaterials Purchase Summary - 360 View
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <RawMaterialsDashboard />
            </Modal.Body>
          </Modal>
        </div>
      </>
    );
  }
}

/* =======================================================
   RawMaterialPurchaseOrdersTable
======================================================= */
export class RawMaterialPurchaseOrdersTable extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      filtered: [],
      reload: false,
      editModalShow: false,
      editPO: null,
      categories: [],
      selectedPO: null, // track the PO for upload/delete actions
      loadSpinnerOpen: false,
    };
    this.inputFile = React.createRef();
  }

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  componentDidMount() {
    this.setState(
      { filtered: this.props.rawmaterialpurchaseorders || [] },
      () => this.setState({ reload: true })
    );
    this.GetRawMaterialCategories();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.rawmaterialpurchaseorders !==
      this.props.rawmaterialpurchaseorders
    ) {
      this.setState({
        filtered: this.props.rawmaterialpurchaseorders || [],
      });
    }
  }

  onUploadButtonClick = (po) => {
    // set the PO we are uploading for and trigger file select
    this.setState({ selectedPO: po }, () => {
      this.inputFile.current?.click();
    });
  };

  handleFileUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;

    const po = this.state.selectedPO;
    if (!po || !po.id) {
      Swal.fire("Error", "No Purchase Order selected for upload.", "error");
      e.target.value = null;
      return;
    }

    this.ShowLoadSpinner();
    try {
      const file = files[0];
      const extension = file.name.split(".").pop();
      const targetFileName = `${po.id}.${extension}`;

      const blobService = new BlobServiceClient(
        `${this.context.store.storageBlobUrl}${this.context.store.storageSasToken}`
      );
      const containerClient = blobService.getContainerClient(
        this.context.store.storageBlobContainerName
      );

      const blobClient = containerClient.getBlockBlobClient(
        `po-orders/${targetFileName}`
      );

      await blobClient.uploadData(file, {
        blobHTTPHeaders: { blobContentType: file.type },
      });

      // Update backend with the new filename (send minimal payload: id + attachmentFileName)
      const res = await fetch(
        `${process.env.REACT_APP_API}Rawmaterials/UpdateRawMaterialsPurchaseAttachmentFileName/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: po.id,
            attachmentFileName: targetFileName,
          }),
        }
      );

      if (!res.ok) {
        throw new Error(`Server returned ${res.status}`);
      }

      Swal.fire("Success", "Attachment uploaded.", "success");
      // refresh parent list if provided
      this.props.refresh && this.props.refresh();
    } catch (err) {
      console.error("Upload failed", err);
      Swal.fire("Error", "File upload failed. Try again.", "error");
    } finally {
      this.HideLoadSpinner();
      e.target.value = null;
      this.setState({ selectedPO: null });
    }
  };

  deleteBlobInContainer = async (po) => {
    if (!po?.attachmentFileName) {
      Swal.fire("Info", "No attachment to delete.", "info");
      return;
    }

    const confirmed = await Swal.fire({
      title: "Confirm",
      text: "Delete attachment for this PO?",
      icon: "warning",
      showCancelButton: true,
    });
    if (!confirmed.isConfirmed) return;

    this.ShowLoadSpinner();
    try {
      const blobService = new BlobServiceClient(
        `${this.context.store.storageBlobUrl}${this.context.store.storageSasToken}`
      );
      const containerClient = blobService.getContainerClient(
        this.context.store.storageBlobContainerName
      );
      const blobClient = containerClient.getBlockBlobClient(
        `po-orders/${po.attachmentFileName}`
      );
      await blobClient.deleteIfExists({ deleteSnapshots: "include" });

      // Update backend with empty filename
      const res = await fetch(
        `${process.env.REACT_APP_API}Rawmaterials/UpdateRawMaterialsPurchaseAttachmentFileName/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: po.id, attachmentFileName: "" }),
        }
      );

      if (!res.ok) {
        throw new Error(`Server returned ${res.status}`);
      }

      Swal.fire("Deleted", "Attachment removed.", "success");
      this.props.refresh && this.props.refresh();
    } catch (err) {
      console.error("Delete failed", err);
      Swal.fire("Error", "Failed to delete attachment.", "error");
    } finally {
      this.HideLoadSpinner();
    }
  };

  GetRawMaterialCategories = () => {
    try {
      const storeId = this.context.storeId;
      if (!storeId) return;
      fetch(
        `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialCategories/${storeId}`
      )
        .then((r) => r.json())
        .then((data) => {
          if (data && Array.isArray(data)) this.setState({ categories: data });
        })
        .catch((err) => console.error("GetRawMaterialCategories error", err));
    } catch (e) {
      console.error(e);
    }
  };

  /** ---------------------- SEARCH ---------------------- **/
  onSearchChange = (query) => {
    if (!query) {
      this.setState({ filtered: this.props.rawmaterialpurchaseorders || [] });
      return;
    }
    const fuse = new Fuse(this.props.rawmaterialpurchaseorders || [], {
      keys: ["invoiceNo", "poNumber", "purchaseOrderNo"],
      threshold: 0.3,
      ignoreLocation: true,
      distance: 120,
    });
    const res = fuse.search(query).map((r) => r.item);
    this.setState({ filtered: res.slice(0, 200) });
  };

  /** ---------------------- HELPER CALCS ---------------------- **/
  getTotalPaid = (po) => {
    const payments =
      po?.rawmaterialsPurchaseOrderPayments ||
      po?.rawMaterialsPurchaseOrderPayments ||
      [];
    return (payments || []).reduce((s, p) => s + (Number(p.amount) || 0), 0);
  };

  getPurchaseTotal = (po) => {
    const items = po.rawMaterialsPurchaseOrderItems || [];
    let subtotal = 0;
    let tax = 0;

    items.forEach((v) => {
      const rate = Number(v.rate) || 0;
      const qty = Number(v.qty) || 0;
      const discount = Number(v.discount) || 0;
      const itemTax = Number(v.tax) || 0;

      const stotal = rate * qty - (rate * qty * discount) / 100;
      subtotal += stotal;
      tax += (stotal * itemTax) / 100;
    });

    const poTaxPct = Number(po.taxPercentage) || 0;
    const purchaseTax = (subtotal * poTaxPct) / 100;
    const loading = Number(po.loadingCharges) || 0;
    const transport = Number(po.transportationCharges) || 0;

    return subtotal + tax + purchaseTax + loading + transport;
  };

  /** ---------------------- UI HELPERS ---------------------- **/
  GetWarehouseName = (id) => {
    if (!id) return "";
    const wh = (this.props.rawmaterialwarehouse || []).find(
      (w) => String(w.id) === String(id)
    );
    return wh ? wh.name : "";
  };

  GetCategoryName = (id) => {
    if (!id) return "";
    const cat = (this.props.rawmaterialcategories || []).find(
      (c) => String(c.id) === String(id)
    );
    return cat ? cat.name : "";
  };

  GetIndentRefLabel = (po, item) => {
    if (!item.indentItemId) return "";

    const itemName = item.itemName || item.ItemName || "";
    return `${itemName}`;
  };

  /** ---------------------- MODALS ---------------------- **/
  openEditModal = (po, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    this.setState({ editModalShow: true, editPO: po });
  };

  closeEditModal = () => {
    this.setState({ editModalShow: false, editPO: null }, () => {
      this.props.refresh && this.props.refresh();
    });
  };

  /** ---------------------- DELETE ---------------------- **/
  onDelete = async (po, e) => {
    if (e?.stopPropagation) e.stopPropagation();
    if (!po?.id) {
      Swal.fire("Information", "Invalid row. Refresh and try again.", "info");
      return;
    }

    const confirm = await Swal.fire({
      title: "Warning!",
      text: "This action will delete associated details as well. Proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
    });
    if (!confirm.isConfirmed) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API}Rawmaterials/DeleteRawMaterialsPurchase/${po.id}`,
        { method: "DELETE", headers: { "Content-Type": "application/json" } }
      );
      if (!res.ok) {
        Swal.fire(
          "Not deleted",
          "This Purchase Order may be associated with other records. Disassociate first and retry.",
          "error"
        );
        return;
      }
      Swal.fire("Deleted", "Purchase Order deleted successfully", "success");
      this.props.OnDeleted && this.props.OnDeleted();
    } catch (err) {
      Swal.fire("Error", "Delete failed: " + String(err), "error");
    }
  };

  /** ---------------------- HEADER ---------------------- **/
  renderHeader = (po) => {
    const invoiceNo = po.invoiceNo || "-";
    const dateStr = po.invoiceDate
      ? this.context.GetInDateFormat(new Date(po.invoiceDate))
      : "-";
    const supplier = (this.props.rawmaterialsuppliers || []).find(
      (s) => String(s.id) === String(po.supplierId)
    )?.name;
    const total = this.getPurchaseTotal(po);
    const paid = this.getTotalPaid(po);

    return (
      <div
        className="d-flex w-100 align-items-center justify-content-between flex-wrap gap-2"
        style={{ fontSize: "0.9rem" }}
      >
        {/* Left */}
        <div className="d-flex align-items-center gap-3">
          <div className="fw-semibold">{dateStr}</div>
          <div className="text-muted">Inv: {invoiceNo}</div>
          <Badge bg="secondary">
            {Number(po.paymentStatusId) === 1
              ? "Paid"
              : Number(po.paymentStatusId) === 2
              ? "Unpaid"
              : Number(po.paymentStatusId) === 3
              ? "Partially Paid"
              : "Unknown"}
          </Badge>
        </div>

        {/* Middle */}
        <div className="d-flex align-items-center gap-4 text-muted">
          <small>
            Supplier:&nbsp;
            <span className="text-dark fw-semibold">{supplier || "-"}</span>
          </small>

          <small>
            Total:&nbsp;
            <span className="text-dark fw-semibold">
              {Number(total || 0).toLocaleString(
                this.context.storeSettings?.defaultLocale || "en-IN",
                {
                  style: "currency",
                  currency:
                    this.context.storeSettings?.defaultCurrency || "INR",
                }
              )}
            </span>
          </small>

          <small>
            Paid:&nbsp;
            <span className="text-dark fw-semibold">
              {Number(paid || 0).toLocaleString(
                this.context.storeSettings?.defaultLocale || "en-IN",
                {
                  style: "currency",
                  currency:
                    this.context.storeSettings?.defaultCurrency || "INR",
                }
              )}
            </span>
          </small>

          <small>
            CreatedBy:&nbsp;
            <span className="text-dark fw-semibold">{po.createdBy || "-"}</span>
          </small>
        </div>

        {/* Right */}
        <div className="d-flex align-items-center gap-3">
          <input
            style={{ display: "none" }}
            accept=".png,.jpg,.jpeg,.pdf"
            ref={this.inputFile}
            onChange={this.handleFileUpload}
            type="file"
          />

          {!po.attachmentFileName ? (
            <small className="text-muted">
              Attachment:&nbsp;
              <Link
                // className="text-success text-decoration-none fw-semibold"
                onClick={() => this.onUploadButtonClick(po)}
              >
                Click to attach
              </Link>
            </small>
          ) : (
            <small className="text-muted d-flex align-items-center gap-2">
              <a
                href={`${this.context.store.storageBlobUrl}${this.context.store.storageBlobContainerName}/po-orders/${po.attachmentFileName}${this.context.store.storageSasToken}`}
                target="_blank"
                rel="noreferrer"
                // className="text-success text-decoration-none fw-semibold"
              >
                View Attachment
              </a>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => this.deleteBlobInContainer(po)}
              >
                X
              </Button>
            </small>
          )}

          <ButtonGroup size="sm" className="ms-2">
            <OverlayTrigger overlay={<Tooltip>Edit</Tooltip>}>
              <Button
                variant="primary"
                onClick={(e) => this.openEditModal(po, e)}
                className="mx-2"
              >
                Open
              </Button>
            </OverlayTrigger>

            <OverlayTrigger
              overlay={
                <Tooltip>Delete (will remove associated details)</Tooltip>
              }
            >
              <Button
                variant="danger"
                className="rounded-circle"
                onClick={(e) => this.onDelete(po, e)}
                disabled={
                  this.context.UserRoles.PRODUCTADMIN !==
                  this.context.userData.roleId
                }
              >
                X
              </Button>
            </OverlayTrigger>
          </ButtonGroup>
        </div>
      </div>
    );
  };

  /** ---------------------- ITEM TABLE ---------------------- **/
  renderItems = (po) => {
    const items = po.rawMaterialsPurchaseOrderItems || [];
    if (!items.length) return <div className="text-muted">No items.</div>;

    return (
      <div className="table-responsive">
        <Table hover size="sm" className="mb-2">
          <thead>
            <tr className="text-center align-middle">
              <th>#</th>
              <th className="text-start">RM Name</th>
              <th>Thickness</th>
              <th>Width</th>
              <th>BatchId</th>
              <th>InternalId</th>
              <th>HSNCode</th>
              <th>Remarks</th>
              <th>Pieces</th>
              <th>Qty/Wt</th>
              <th>LocalWt</th>
              <th>Rate</th>
              <th>Unit</th>
              <th>S.Total</th>
              <th>Indent Ref</th>
              <th>Category</th>
              <th>Warehouse</th>
              <th>InStock</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it, idx) => {
              const rate = Number(it.rate) || 0;
              const qty = Number(it.qty) || 0;
              const subtotal = rate * qty;
              const indentRef = this.GetIndentRefLabel(po, it);
              const catName =
                it.categoryName ||
                this.GetCategoryName(it.categoryId) ||
                this.state.categories.find(
                  (c) => String(c.id) === String(it.categoryId)
                )?.name ||
                "-";

              const whName =
                it.warehouseName ||
                this.GetWarehouseName(it.warehouseId) ||
                "-";
              return (
                <tr key={it.id || idx} className="text-center align-middle">
                  <td>{idx + 1}</td>
                  <td className="text-start">{it.itemName}</td>
                  <td>{it.thickness || ""}</td>
                  <td>{it.width || ""}</td>
                  <td>{it.batchId || ""}</td>
                  <td>{it.internalId || ""}</td>
                  <td>{it.hsnCode || ""}</td>
                  <td>{it.remarks || ""}</td>
                  <td>{it.pieces || ""}</td>
                  <td>{it.qty || ""}</td>
                  <td>{it.localWt || ""}</td>
                  <td>{it.rate || ""}</td>
                  <td>{it.unit || ""}</td>
                  <td className="text-end">
                    {subtotal.toLocaleString("en-IN", {
                      style: "currency",
                      currency: "INR",
                    })}
                  </td>
                  <td>{indentRef || ""}</td>
                  <td>{catName}</td>
                  <td>{whName}</td>
                  <td>
                    {it.addedToStock ? (
                      <Badge bg="success">Added</Badge>
                    ) : (
                      <Badge bg="secondary">Pending</Badge>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  /** ---------------------- RENDER ---------------------- **/
  render() {
    const rows = (this.state.filtered || [])
      .filter((f) => Number(f.paymentStatusId) === Number(this.props.status))
      .sort((a, b) => new Date(a.created) - new Date(b.created));

    return (
      <>
        <Row className="mb-2 mx-3">
          <Col md={12}>
            <Stack direction="horizontal" gap={3}>
              <b>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-search"
                  viewBox="0 0 16 16"
                >
                  <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                </svg>
              </b>
              <FormControl
                type="search"
                placeholder="Search InvoiceNo / PO Number"
                aria-label="Search by invoice no"
                onChange={(e) => this.onSearchChange(e.target.value)}
              />
            </Stack>
          </Col>
        </Row>

        <div className="mx-4">
          <Accordion alwaysOpen>
            {rows.map((po, idx) => {
              const prId = String(po.id || idx);
              return (
                <Accordion.Item eventKey={prId} key={prId} className="mb-2">
                  <Accordion.Header>{this.renderHeader(po)}</Accordion.Header>
                  <Accordion.Body>{this.renderItems(po)}</Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>

        {this.state.editModalShow && (
          <RawMaterialPurchaseOrderAddOrEditModal
            show={true}
            onHide={this.closeEditModal}
            purchaseOrder={this.state.editPO}
            rawmaterialsuppliers={this.props.rawmaterialsuppliers}
            Type="Edit"
            prods={this.props.prods}
            GetRawMaterialsInventories={this.props.GetRawMaterialsInventories}
            rawmaterialwarehouse={this.props.rawmaterialwarehouse}
          />
        )}
      </>
    );
  }
}

/* =======================================================
   RawMaterialPurchaseOrderAddOrEditModal
======================================================= */

export class RawMaterialPurchaseOrderAddOrEditModal extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      purchaseOrder: {
        id: undefined,
        invoiceDate: new Date(),
        paidAmount: 0,
        taxPercentage: 0,
        loadingCharges: 0,
        transportationCharges: 0,
      },
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      loadSpinnerOpen: false,
      rawMaterialsPurchaseOrderItems: [],

      showOrderItemModal: false,
      editPurchaseItemRow: 0,
      editModalShow: false,

      rawmaterialsPurchaseOrderPayments: [], // payments
      showPaymentModal: false,
      editPaymentRow: -1,
      editPaymentModalShow: false,

      purchaseRequests: [], // list of indents (headers)
      selectedPurchaseRequestId: "", // selected request id (string)
      loadedIndentItems: [], // items of selected purchase request (for dropdown)
      loadModeReplace: false, // if true, replace existing items; else append

      categories: [],

      rawmaterialsPurchaseOrderPayments: [],
      showPaymentModal: false,
      editPaymentModalShow: false,
      editPaymentRow: -1,
    };
    this._keyListener = this._keyListener.bind(this);
  }

  /* --- Payment handlers --- */
  AddPurchasePayment = (payment) => {
    this.setState((prev) => ({
      rawmaterialsPurchaseOrderPayments: [
        ...prev.rawmaterialsPurchaseOrderPayments,
        { ...payment, id: payment.id || this.GenerateGuid() },
      ],
      showPaymentModal: false,
      editPaymentModalShow: false,
    }));
  };

  UpdatePurchasePayment = (payment, index) => {
    const list = [...this.state.rawmaterialsPurchaseOrderPayments];
    list[index] = { ...list[index], ...payment };
    this.setState({
      rawmaterialsPurchaseOrderPayments: list,
      editPaymentModalShow: false,
    });
  };

  RemovePurchasePayment = (index) => {
    const list = [...this.state.rawmaterialsPurchaseOrderPayments];
    list.splice(index, 1);
    this.setState({ rawmaterialsPurchaseOrderPayments: list });
  };

  OpenAddPayment = () => this.setState({ showPaymentModal: true });
  OnEditPaymentClick = (e, i) =>
    this.setState({ editPaymentRow: i, editPaymentModalShow: true });

  /* ---------------- utilities & helpers ---------------- */
  asNumber = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  };

  GetRawMaterialCategories = () => {
    try {
      const storeId = this.context.storeId;
      if (!storeId) return;
      fetch(
        `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialCategories/${storeId}`
      )
        .then((r) => r.json())
        .then((data) => {
          this.setState({ categories: Array.isArray(data) ? data : [] });
        })
        .catch((err) => {
          console.error("GetRawMaterialCategories error", err);
          this.setState({ categories: [] });
        });
    } catch (e) {
      console.error(e);
    }
  };

  // Category lookup helper
  GetCategoryName = (categoryId) => {
    if (!categoryId) return "";
    const cats = this.state.categories;
    const found = cats.find((c) => String(c.id) === String(categoryId));
    return found ? found.name : "";
  };

  GetWarehouseName = (id) => {
    const result = (this.props.rawmaterialwarehouse || []).find(
      (f) => String(f.id) === String(id)
    );
    return result?.name || "";
  };

  GetProductInfo = (row) => {
    let result = row?.itemName || "";
    // if (row?.batchId)
    //   result +=
    //     this.context.store.businessTypeId ===
    //     this.context.BusinessTypes.STEELTRADERS
    //       ? ` CoilId:${row.batchId}`
    //       : ` BatchId:${row.batchId}`;
    // if (row?.remarks) result += ` ${row.remarks}`;
    return result;
  };

  GetPaymentMethodName = (method) => {
    const m = Number(method);
    switch (m) {
      case 1:
        return "Cash";
      case 2:
        return "Bank Transfer";
      case 3:
        return "Cheque";
      case 4:
        return "UPI";
      case 5:
        return "Razorpay";
      default:
        return method ? String(method) : "Other";
    }
  };
  GetTotalPayments = () => {
    return (this.state.rawmaterialsPurchaseOrderPayments || []).reduce(
      (sum, p) => sum + this.asNumber(p.amount),
      0
    );
  };

  // Return a user-visible label for an indent reference.
  // Accepts either an indentId (string) or an indent object.
  GetIndentRefLabel = (indentOrId) => {
    if (!indentOrId) return "";

    // Resolve indent item object from loadedIndentItems
    const loadedItem = (this.state.loadedIndentItems || []).find(
      (r) => String(r.id) === String(indentOrId.id || indentOrId)
    );

    // Try to get PO number from selected purchase request
    const selectedRequest = (this.state.purchaseRequests || []).find(
      (pr) => String(pr.id) === String(this.state.selectedPurchaseRequestId)
    );

    const itemName =
      loadedItem?.itemName || indentOrId.itemName || indentOrId.ItemName || "";
    const qty =
      loadedItem?.qty ??
      indentOrId.qty ??
      indentOrId.Qty ??
      indentOrId.quantity ??
      "";
    const qtyStr =
      qty !== "" && qty !== null && !isNaN(Number(qty))
        ? ` x ${Number(qty)}`
        : "";

    // Format like: "PO1234 — Sheet Coil x 3"
    const parts = [];
    if (itemName) parts.push(`${itemName}${qtyStr}`);

    return parts.length > 0 ? parts.join(" — ") : "";
  };

  /* ---------------- load purchase-requests list ---------------- */
  LoadPurchaseRequests = () => {
    try {
      const storeId = this.context.storeId;
      if (!storeId) return Promise.resolve([]);
      return fetch(
        `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialPurchaseRequest/${storeId}`
      )
        .then((res) => res.json())
        .then((data) => {
          const list = Array.isArray(data) ? data : [];
          // normalize ids to string
          const normalized = list.map((pr) => ({ ...pr, id: String(pr.id) }));
          this.setState({ purchaseRequests: normalized });
          return normalized;
        })
        .catch((err) => {
          console.error("LoadPurchaseRequests error", err);
          this.setState({ purchaseRequests: [] });
          return [];
        });
    } catch (e) {
      console.error("LoadPurchaseRequests exception", e);
      this.setState({ purchaseRequests: [] });
      return Promise.resolve([]);
    }
  };

  /* ---------------- when user selects a PR from dropdown ----------------
     - fetches the PR items and also imports them into purchase items table (no duplicates)
     - sets selectedPurchaseRequestId and purchaseOrder.purchaseRequestId
  */
  OnSelectPurchaseRequest = (e) => {
    const val = e.target.value;
    const selectedId = val ? String(val) : "";
    this.setState({ selectedPurchaseRequestId: selectedId });

    if (!selectedId) {
      // clear loaded indent items and header id
      this.setState((prev) => ({
        loadedIndentItems: [],
        purchaseOrder: {
          ...prev.purchaseOrder,
          purchaseRequestId: "",
        },
      }));
      return;
    }

    this.ShowLoadSpinner();
    fetch(
      `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsPurchaseRequestById/${selectedId}`
    )
      .then((res) => res.json())
      .then((data) => {
        this.HideLoadSpinner();
        if (!data) {
          Swal.fire("Error", "Could not load purchase request.", "error");
          return;
        }

        const prItems = Array.isArray(data.rawMaterialsPurchaseRequestItems)
          ? data.rawMaterialsPurchaseRequestItems
          : Array.isArray(data.RawMaterialsPurchaseRequestItems)
          ? data.RawMaterialsPurchaseRequestItems
          : [];

        // store raw indent items for the item modal dropdown
        // also import rows into Purchase Items table (without duplicates)
        const mapped = prItems.map((it, idx) => ({
          id: this.GenerateGuid(),
          seqNo: idx + 1,
          itemId: it.itemId || it.ItemId || null,
          itemName: it.itemName || it.ItemName || "",
          qty: it.qty ?? it.Qty ?? it.quantity ?? 0,
          unit: it.unit || it.Unit || "",
          rate: it.purchasePrice || it.PurchasePrice || 0,
          discount: 0,
          tax: 0,
          batchId: it.batchId || it.BatchId || "", // CoilId
          hsnCode: it.hsnCode || it.HSNCode || "",
          internalId: it.internalId || it.InternalId || "",
          remarks: it.notes || it.Notes || "",
          thickness: it.thickness ?? it.Thickness ?? null,
          width: it.width ?? it.Width ?? null,
          pieces: it.pieces || it.Pieces || 0,
          localWt: it.weight || it.LocalWt || it.localWt || 0,
          warehouseId: it.warehouseId || it.WarehouseId || null,
          warehouseName: this.GetWarehouseName(
            it.warehouseId || it.WarehouseId || null
          ),
          addedToStock: false,
          indentItemId: it.id || it.Id || null,
          categoryId:
            it.categoryId ||
            (this.props.prods || []).find(
              (p) => String(p.id) === String(it.itemId)
            )?.categoryId ||
            null,
          categoryName:
            this.GetCategoryName(
              it.categoryId ||
                (this.props.prods || []).find(
                  (p) => String(p.id) === String(it.itemId)
                )?.categoryId
            ) || "",
        }));

        this.setState((prev) => {
          // dedupe by indentItemId (only add those not already present)
          const existingIndentIds = new Set(
            (prev.rawMaterialsPurchaseOrderItems || [])
              .map((r) => (r.indentItemId ? String(r.indentItemId) : null))
              .filter(Boolean)
          );

          const toAdd = mapped.filter(
            (m) =>
              m.indentItemId && !existingIndentIds.has(String(m.indentItemId))
          );

          const nextSeqBase = (prev.rawMaterialsPurchaseOrderItems || [])
            .length;

          const withSeq = toAdd.map((m, i) => ({
            ...m,
            seqNo: nextSeqBase + i + 1,
          }));

          return {
            loadedIndentItems: prItems,
            rawMaterialsPurchaseOrderItems: [
              ...(prev.rawMaterialsPurchaseOrderItems || []),
              ...withSeq,
            ],
            purchaseOrder: {
              ...prev.purchaseOrder,
              purchaseRequestId: data.id || data.Id || selectedId,
              purchaseOrderNo:
                prev.purchaseOrder.purchaseOrderNo ||
                data.purchaseOrderNo ||
                data.PurchaseOrderNo ||
                "",
            },
          };
        });
      })
      .catch((err) => {
        this.HideLoadSpinner();
        console.error("OnSelectPurchaseRequest error", err);
        Swal.fire("Error", "Failed to load purchase request items.", "error");
      });
  };

  // Optional button - kept for compatibility
  LoadSelectedPurchaseRequestItems = () => {
    const id = this.state.selectedPurchaseRequestId;
    if (!id) {
      Swal.fire("Info", "Select a Purchase Request first.", "info");
      return;
    }

    this.ShowLoadSpinner();
    fetch(
      `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsPurchaseRequestById/${id}`
    )
      .then((res) => res.json())
      .then((data) => {
        this.HideLoadSpinner();
        if (!data) {
          Swal.fire("Error", "Could not load purchase request.", "error");
          return;
        }

        const prItems = Array.isArray(data.rawMaterialsPurchaseRequestItems)
          ? data.rawMaterialsPurchaseRequestItems
          : [];

        const mapped = prItems.map((it, idx) => ({
          id: this.GenerateGuid(),
          seqNo: idx + 1,
          itemId: it.itemId || null,
          itemName: it.itemName || "",
          qty: it.qty || 0,
          unit: it.unit || "",
          rate: it.purchasePrice || 0,
          discount: 0,
          tax: 0,
          batchId: it.batchId || "",
          hsnCode: it.hsnCode || "",
          internalId: it.internalId || "",
          qualityId: it.qualityId || "",
          remarks: it.notes || it.Notes || "",
          thickness: it.thickness ?? null,
          width: it.width ?? null,
          pieces: it.pieces || 0,
          localWt: it.localWt || 0,
          warehouseId: it.warehouseId || null,
          addedToStock: false,
          indentItemId: it.id || null,
          categoryId:
            it.categoryId ||
            (this.props.prods || []).find(
              (p) => String(p.id) === String(it.itemId)
            )?.categoryId ||
            null,
          categoryName:
            this.GetCategoryName(
              it.categoryId ||
                (this.props.prods || []).find(
                  (p) => String(p.id) === String(it.itemId)
                )?.categoryId
            ) || "",
        }));

        this.setState((prev) => ({
          rawMaterialsPurchaseOrderItems: [
            ...(prev.rawMaterialsPurchaseOrderItems || []),
            ...mapped,
          ],
          purchaseOrder: {
            ...prev.purchaseOrder,
            purchaseOrderNo:
              data.purchaseOrderNo || prev.purchaseOrder.purchaseOrderNo || "",
            purchaseRequestId: data.id || prev.purchaseOrder.purchaseRequestId,
          },
        }));

        Swal.fire(
          "Loaded",
          `Loaded ${mapped.length} item(s) from selected PR.`,
          "success"
        );
      })
      .catch((err) => {
        this.HideLoadSpinner();
        console.error("LoadSelectedPurchaseRequestItems error", err);
        Swal.fire("Error", "Failed to load items.", "error");
      });
  };

  /* --- Payments handlers --- */
  AddPurchasePayment = (payment) => {
    this.setState((prev) => ({
      rawmaterialsPurchaseOrderPayments: [
        ...prev.rawmaterialsPurchaseOrderPayments,
        { ...payment, id: payment.id || this.GenerateGuid() },
      ],
      showPaymentModal: false,
      editPaymentModalShow: false,
    }));
  };

  UpdatePurchasePayment = (payment, index) => {
    const list = [...this.state.rawmaterialsPurchaseOrderPayments];
    list[index] = { ...list[index], ...payment };
    this.setState({
      rawmaterialsPurchaseOrderPayments: list,
      editPaymentModalShow: false,
    });
  };

  RemovePurchasePayment = (index) => {
    const list = [...this.state.rawmaterialsPurchaseOrderPayments];
    list.splice(index, 1);
    this.setState({ rawmaterialsPurchaseOrderPayments: list });
  };

  OpenAddPayment = () => this.setState({ showPaymentModal: true });
  OnEditPaymentClick = (e, i) =>
    this.setState({ editPaymentRow: i, editPaymentModalShow: true });

  GenerateGuid = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  };

  /* --- totals --- */
  GetTotalOfPurchaseOrderWithoutTax = (items) =>
    (items || []).reduce(
      (sum, v) => sum + this.asNumber(v.rate) * this.asNumber(v.qty),
      0
    );

  GetTotalOfPurchaseOrderTaxAmount = (items) =>
    (items || []).reduce(
      (sum, v) =>
        sum +
        (this.asNumber(v.rate) * this.asNumber(v.qty) * this.asNumber(v.tax)) /
          100,
      0
    );

  // Use context helper if available; fallback to simple discount+tax calc
  GetTotalOfPurchaseOrder = (items) =>
    (items || []).reduce((sum, v) => {
      if (this.context && typeof this.context.ReturnwithTax === "function") {
        return (
          sum +
          this.context.ReturnwithTax(
            this.asNumber(v.rate),
            this.asNumber(v.qty),
            this.asNumber(v.discount),
            this.asNumber(v.tax)
          )
        );
      }
      // fallback:
      const amountBeforeDiscount = this.asNumber(v.rate) * this.asNumber(v.qty);
      const afterDiscount =
        amountBeforeDiscount -
        (amountBeforeDiscount * this.asNumber(v.discount)) / 100;
      const taxAmount = (afterDiscount * this.asNumber(v.tax)) / 100;
      return sum + afterDiscount + taxAmount;
    }, 0);

  GetPurchaseLevelTaxAmount = (items) => {
    const subtotal = this.GetTotalOfPurchaseOrderWithoutTax(items);
    const po = this.state.purchaseOrder || {};
    const pct = this.asNumber(po.taxPercentage);
    if (!pct) return 0;
    return (this.asNumber(subtotal) * pct) / 100;
  };

  GetGrandTotal = (items) => {
    const subtotal = this.GetTotalOfPurchaseOrderWithoutTax(items);
    const itemTax = this.GetTotalOfPurchaseOrderTaxAmount(items);
    const purchaseTax = this.GetPurchaseLevelTaxAmount(items);
    const po = this.state.purchaseOrder || {};
    const loading = this.asNumber(po.loadingCharges);
    const transport = this.asNumber(po.transportationCharges);
    return (
      this.asNumber(subtotal) +
      this.asNumber(itemTax) +
      this.asNumber(purchaseTax) +
      this.asNumber(loading) +
      this.asNumber(transport)
    );
  };

  /* ---------------- lifecycle ---------------- */
  componentDidMount() {
    document.addEventListener("keydown", this._keyListener);

    // load PR list early (so dropdown shows quickly)
    if (this.context?.storeId) {
      this.LoadPurchaseRequests();
    }
    this.GetRawMaterialCategories();

    // If editing, fetch PO and also ensure PR list is available
    if (this.props.Type === "Edit" && this.props.purchaseOrder?.id) {
      this.GetPurchaseOrderById(this.props.purchaseOrder.id);
    }
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this._keyListener);
  }
  _keyListener(e) {
    if (e.key === "F8") this.handleAddItems(e);
  }

  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
    this.props.onHide?.();
  };
  ShowMessagBox = (title, message) =>
    this.setState({
      msgboxOpen: true,
      msgboxTitle: title,
      msgboxMessage: message,
    });
  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  /* ---------------- GET Purchase Order (FULL) ----------------
     - Normalizes item fields (indentItemId, itemId, qty, rate, category)
     - Loads purchaseRequests list (if not already loaded) and resolves selectedPurchaseRequestId
     - Ensures loadedIndentItems is populated so Indent dropdowns show labels in edit
  */
  GetPurchaseOrderById = (Id) => {
    if (!Id) return;
    this.ShowLoadSpinner();

    const prPromise = this.LoadPurchaseRequests(); // returns array
    const poPromise = fetch(
      `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsPurchaseById/${Id}`
    ).then((r) => r.json());

    Promise.all([prPromise, poPromise])
      .then(([purchaseRequests, data]) => {
        this.HideLoadSpinner();

        if (!data || data.status === 400) return;

        // normalize items (camelCase expected from backend)
        const rawItems = Array.isArray(data.rawMaterialsPurchaseOrderItems)
          ? data.rawMaterialsPurchaseOrderItems
          : [];

        const items = rawItems
          .map((it, idx) => {
            const indentId =
              it.indentItemId || it.IndentItemId || it.indentId || null;
            const itemId = it.itemId || it.ItemId || null;
            const categoryId =
              it.categoryId ||
              (this.props.prods || []).find(
                (p) => String(p.id) === String(itemId)
              )?.categoryId ||
              null;
            return {
              ...it,
              id: it.id || this.GenerateGuid(),
              seqNo: it.seqNo ?? idx + 1,
              itemId,
              qty: it.qty ?? it.Qty ?? 0,
              rate:
                it.rate ?? it.Rate ?? it.purchasePrice ?? it.PurchasePrice ?? 0,
              indentItemId: indentId,
              categoryId,
              categoryName: this.GetCategoryName(categoryId),
              warehouseId: it.warehouseId || it.WarehouseId || null,
              warehouseName: this.GetWarehouseName(
                it.warehouseId || it.WarehouseId || null
              ),
              // ensure UI fields exist:
              batchId: it.batchId || it.BatchId || "",
              hsnCode: it.hsnCode || it.HSNCode || "",
              internalId: it.internalId || it.InternalId || "",
              remarks: it.remarks || it.Remarks || it.notes || it.Notes || "",
              thickness: it.thickness ?? it.Thickness ?? null,
              width: it.width ?? it.Width ?? null,
            };
          })
          .sort((a, b) => this.asNumber(a.seqNo) - this.asNumber(b.seqNo));

        // normalize payments
        const payments = Array.isArray(data.rawmaterialsPurchaseOrderPayments)
          ? data.rawmaterialsPurchaseOrderPayments.sort((a, b) => {
              const da = a?.paymentDate ? new Date(a.paymentDate) : new Date(0);
              const db = b?.paymentDate ? new Date(b.paymentDate) : new Date(0);
              return da - db;
            })
          : [];

        // Try to resolve purchaseRequestId / selectedPurchaseRequestId
        const poNo = data.purchaseOrderNo || data.PurchaseOrderNo || "";
        const prIdFromPo =
          data.purchaseRequestId || data.purchaseRequestId || "";

        // prefer direct PR id; else try match by purchaseOrderNo; else try to find a PR containing any indentItemId
        let resolvedPrId = prIdFromPo ? String(prIdFromPo) : "";

        if (!resolvedPrId && poNo) {
          const foundByPoNo = (purchaseRequests || []).find(
            (pr) =>
              String(pr.purchaseOrderNo || pr.PurchaseOrderNo || "") ===
              String(poNo)
          );
          if (foundByPoNo) resolvedPrId = String(foundByPoNo.id);
        }

        const indentIds = items
          .map((it) => it.indentItemId)
          .filter(Boolean)
          .map((id) => String(id));

        const fetchPrItemsIfNeeded = () => {
          if (
            resolvedPrId ||
            !purchaseRequests ||
            purchaseRequests.length === 0 ||
            indentIds.length === 0
          )
            return Promise.resolve(resolvedPrId);

          // fetch each PR in parallel and check if it contains any indent ids
          const prFetches = purchaseRequests.map((pr) =>
            fetch(
              `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsPurchaseRequestById/${pr.id}`
            )
              .then((r) => r.json())
              .then((prData) => {
                const prItems = Array.isArray(
                  prData.rawMaterialsPurchaseRequestItems
                )
                  ? prData.rawMaterialsPurchaseRequestItems
                  : [];
                const matches = prItems.some((i) =>
                  indentIds.includes(String(i.id))
                );
                return matches ? String(pr.id) : null;
              })
              .catch(() => null)
          );

          return Promise.all(prFetches).then((results) => {
            const match = results.find((r) => r);
            if (match) resolvedPrId = match;
            return resolvedPrId;
          });
        };

        fetchPrItemsIfNeeded().then((finalPrId) => {
          // set main state
          this.setState(
            {
              purchaseOrder: {
                ...data,
                purchaseOrderNo: poNo,
                purchaseRequestId: prIdFromPo || "",
              },
              rawMaterialsPurchaseOrderItems: items,
              rawmaterialsPurchaseOrderPayments: payments,
              selectedPurchaseRequestId: finalPrId ? String(finalPrId) : "",
            },
            () => {
              // load indent items for whichever PR we resolved (if any)
              const usePrId = finalPrId || prIdFromPo;
              if (usePrId) {
                fetch(
                  `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialsPurchaseRequestById/${usePrId}`
                )
                  .then((res) => res.json())
                  .then((prData) => {
                    const prItems = Array.isArray(
                      prData.rawMaterialsPurchaseRequestItems
                    )
                      ? prData.rawMaterialsPurchaseRequestItems
                      : [];
                    if (prItems.length > 0) {
                      this.setState({ loadedIndentItems: prItems });
                    } else {
                      // fallback: build loaded list from PO rows so edit modal shows label
                      const fallback = items
                        .filter((it) => it.indentItemId)
                        .map((it) => ({
                          id: it.indentItemId,
                          itemName: it.itemName || "",
                          qty: it.qty || 0,
                        }));
                      this.setState({ loadedIndentItems: fallback });
                    }
                  })
                  .catch((err) => {
                    console.warn("Could not load indent items for PR:", err);
                    const fallback = items
                      .filter((it) => it.indentItemId)
                      .map((it) => ({
                        id: it.indentItemId,
                        itemName: it.itemName || "",
                        qty: it.qty || 0,
                      }));
                    this.setState({ loadedIndentItems: fallback });
                  });
              } else {
                // no PR determined -> fallback to building indent list from PO rows
                const fallback = items
                  .filter((it) => it.indentItemId)
                  .map((it) => ({
                    id: it.indentItemId,
                    itemName: it.itemName || "",
                    qty: it.qty || 0,
                  }));
                this.setState({ loadedIndentItems: fallback });
              }
            }
          );
        });
      })
      .catch((err) => {
        this.HideLoadSpinner();
        console.error("GetPurchaseOrderById error", err);
        Swal.fire(
          "Error",
          "Failed to load Purchase Order. Try again.",
          "error"
        );
      });
  };

  AddOrUpdatePurchaseOrderInDB = () => {
    const items = this.state.rawMaterialsPurchaseOrderItems || [];
    if (items.length === 0) {
      Swal.fire({
        title: "Warning",
        text: "Please add Purchased items and try!",
        timer: 3000,
      });
      return;
    }

    // Validate warehouseId & categoryId on each item
    const invalidRow = items.find(
      (it) => !it.warehouseId || !(it.categoryId || it.categoryName)
    );
    if (invalidRow) {
      Swal.fire({
        title: "Validation",
        text: "Each purchase item must have a valid Warehouse and Category. Please correct item(s) and try again.",
        icon: "warning",
      });
      return;
    }

    // ✅ New validation: check for duplicate indent references
    const indentIds = items
      .map((it) => it.indentItemId)
      .filter((id) => id && String(id).trim() !== "");
    const duplicates = indentIds.filter(
      (id, index) => indentIds.indexOf(id) !== index
    );
    if (duplicates.length > 0) {
      const dupCount = [...new Set(duplicates)].length;
      Swal.fire({
        title: "Duplicate Indent Ref Found",
        text: `You have used the same Indent Reference in ${dupCount} item(s). Each indent item can be used only once in a Purchase Order.`,
        icon: "warning",
      });
      return;
    }

    // compute totals and payments sum
    const expectedTotal = this.GetGrandTotal(items);
    const payments = this.state.rawmaterialsPurchaseOrderPayments || [];
    const paymentsSum = payments.reduce(
      (s, p) => s + this.asNumber(p.amount),
      0
    );
    const TOL = 0.01;

    const po = this.state.purchaseOrder || {};

    if (Number(po.paymentStatusId) === 1) {
      if (
        Math.abs(this.asNumber(paymentsSum) - this.asNumber(expectedTotal)) >
        TOL
      ) {
        Swal.fire({
          title: "Warning",
          text: "Paid Amount is not correct!",
          timer: 3000,
        });
        return;
      }
    }

    if (Number(po.paymentStatusId) === 3) {
      if (this.asNumber(paymentsSum) >= this.asNumber(expectedTotal) - TOL) {
        Swal.fire({
          title: "Validation",
          text: "Status is 'Partially Paid' but payments equal or exceed total. Change status or correct payments.",
          icon: "warning",
        });
        return;
      }
    }

    // ✅ Proceed with API call only if all validations pass
    this.ShowLoadSpinner();

    const tmpPurchaseOrder = {
      ...po,
      invoiceDate: new Date(po.invoiceDate),
      rawMaterialsPurchaseOrderItems: items,
      rawmaterialsPurchaseOrderPayments: payments,
      paidAmount: paymentsSum,
      ...(this.props.Type === "Edit"
        ? {}
        : {
            storeId: this.context.storeId,
            createdBy: this.context.userData.emailId,
          }),
    };

    fetch(
      `${process.env.REACT_APP_API}Rawmaterials/AddOrUpdateRawMaterialsPurchase/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(tmpPurchaseOrder),
      }
    )
      .then((res) => {
        this.HideLoadSpinner();
        if (res.status === 200) {
          this.props.onHide?.();
        } else {
          Swal.fire(
            "Duplicate",
            "This Purchase Order already exists. Try again!",
            "error"
          );
        }
      })
      .catch((error) => {
        this.HideLoadSpinner();
        Swal.fire("Exception", `Try after sometime!\n${error}`, "error");
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.AddOrUpdatePurchaseOrderInDB();
  };

  UpdatePurchaseItem = (item, index) => {
    const list = [...this.state.rawMaterialsPurchaseOrderItems];
    // ensure categoryName maintained
    const categoryName =
      item.categoryName ||
      this.GetCategoryName(item.categoryId) ||
      list[index]?.categoryName;
    list[index] = { ...list[index], ...item, categoryName };
    this.setState({
      rawMaterialsPurchaseOrderItems: list,
      editModalShow: false,
    });
  };

  AddPurchaseItem = (item) => {
    const categoryName =
      item.categoryName || this.GetCategoryName(item.categoryId);
    const warehouseName =
      item.warehouseName || this.GetWarehouseName(item.warehouseId);
    this.setState((prev) => ({
      rawMaterialsPurchaseOrderItems: [
        ...prev.rawMaterialsPurchaseOrderItems,
        {
          ...item,
          seqNo: prev.rawMaterialsPurchaseOrderItems.length + 1,
          categoryName,
          warehouseName,
        },
      ],
      showOrderItemModal: false,
      editModalShow: false,
    }));
  };

  handleRemoveClick = (indexno) => {
    const it = this.state.rawMaterialsPurchaseOrderItems[indexno];
    const remove = () => {
      const list = [...this.state.rawMaterialsPurchaseOrderItems];
      list.splice(indexno, 1);
      this.setState({ rawMaterialsPurchaseOrderItems: list });
    };

    if (it?.addedToStock) {
      Swal.fire({
        title: "Warning!",
        confirmButtonColor: "#23B14D",
        cancelButtonColor: "#dbdbdb",
        text: "This item is already added to Inventory Stock. If you delete, you may have to manually correct the InStock on the Inventory. Continue?",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => result.isConfirmed && remove());
    } else remove();
  };

  onHideOrderItemModal = () =>
    this.setState({ showOrderItemModal: false, editModalShow: false });
  handleAddItems = () => this.setState({ showOrderItemModal: true });

  OnEditButtonClick = (e, i) =>
    this.setState({ editPurchaseItemRow: i, editModalShow: true });
  editModalClose = () => this.setState({ editModalShow: false });

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      purchaseOrder: { ...prev.purchaseOrder, [name.trim()]: value },
    }));
  };

  /* ---------------- render ---------------- */
  render() {
    const items = this.state.rawMaterialsPurchaseOrderItems || [];
    const po = this.state.purchaseOrder || {};

    return (
      <div className="container ">
        <Modal
          {...this.props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          fullscreen="sm-down"
          style={{ fontFamily: "sans-serif", fontSize: "12px" }}
          backdrop="static"
          keyboard={false}
          dialogClassName="purchaseorder-modal"
          scrollable
        >
          {this.state.msgboxOpen && (
            <MessageBox
              open={this.state.msgboxOpen}
              title={this.state.msgboxTitle}
              message={this.state.msgboxMessage}
              callback={this.CloseMessagBoxCallback}
            />
          )}
          {this.state.loadSpinnerOpen && <LoadSpinner open />}

          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title id="contained-modal-title-vcenter">
                {this.props.Type === "Edit"
                  ? "Edit Purchase Order"
                  : "Add Purchase Order"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid ">
              {this.state.showOrderItemModal && (
                <AddOrEditRawMaterialPurchaseOrderItem
                  onHide={this.onHideOrderItemModal}
                  AddPurchaseItem={this.AddPurchaseItem}
                  Type="Add"
                  prods={this.props.prods}
                  GetRawMaterialsInventories={
                    this.props.GetRawMaterialsInventories
                  }
                  rawmaterialwarehouse={this.props.rawmaterialwarehouse}
                  // pass loaded indent items for dropdown in item modal
                  indentItems={this.state.loadedIndentItems}
                />
              )}
              {this.state.editModalShow && (
                <AddOrEditRawMaterialPurchaseOrderItem
                  onHide={this.onHideOrderItemModal}
                  UpdatePurchaseItem={this.UpdatePurchaseItem}
                  Type="Edit"
                  purchaseOrderItem={items[this.state.editPurchaseItemRow]}
                  Index={this.state.editPurchaseItemRow}
                  prods={this.props.prods}
                  GetRawMaterialsInventories={
                    this.props.GetRawMaterialsInventories
                  }
                  rawmaterialwarehouse={this.props.rawmaterialwarehouse}
                  indentItems={this.state.loadedIndentItems}
                />
              )}

              {this.state.showPaymentModal && (
                <AddOrEditRawMaterialPurchasePayment
                  onHide={() => this.setState({ showPaymentModal: false })}
                  Type="Add"
                  AddPurchasePayment={this.AddPurchasePayment}
                />
              )}

              {this.state.editPaymentModalShow && (
                <AddOrEditRawMaterialPurchasePayment
                  onHide={() => this.setState({ editPaymentModalShow: false })}
                  Type="Edit"
                  payment={
                    this.state.rawmaterialsPurchaseOrderPayments[
                      this.state.editPaymentRow
                    ]
                  }
                  index={this.state.editPaymentRow}
                  UpdatePurchasePayment={this.UpdatePurchasePayment}
                />
              )}

              <div className="p-1 bg-light border-0 rounded-3">
                <Row className="p-0 " style={{ fontSize: "12pt" }}>
                  <Col md={2}>
                    <FloatingLabel label="Invoice Number*" className="mb-3">
                      <Form.Control
                        type="text"
                        autoFocus
                        id="invoiceNo"
                        name="invoiceNo"
                        maxLength={99}
                        value={po.invoiceNo || ""}
                        required
                        placeholder=""
                        autoComplete="off"
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col>
                  <Col md={2} className="m-0 p-0 text-center align-middle">
                    <FloatingLabel label="Invoice Date *" className="mb-3">
                      <Form.Control
                        type="date"
                        required
                        name="invoiceDate"
                        value={
                          po.invoiceDate
                            ? new Date(po.invoiceDate)
                                .toISOString()
                                .split("T")[0]
                            : ""
                        }
                        onChange={(e) =>
                          this.setState((prev) => ({
                            purchaseOrder: {
                              ...prev.purchaseOrder,
                              invoiceDate: e.target.value,
                            },
                          }))
                        }
                      />
                    </FloatingLabel>
                  </Col>

                  <Col md={3}>
                    <FloatingLabel
                      label="Load from PO Number(indent)"
                      className="mb-3"
                    >
                      <Form.Select
                        name="purchaseRequestSelect"
                        value={this.state.selectedPurchaseRequestId || ""}
                        onChange={this.OnSelectPurchaseRequest}
                        aria-label="Select purchase request (indent)"
                        className="text-start"
                      >
                        <option value="">-- Select PO Indent --</option>

                        {this.state.selectedPurchaseRequestId &&
                          !(this.state.purchaseRequests || []).some(
                            (pr) =>
                              String(pr.id) ===
                              String(this.state.selectedPurchaseRequestId)
                          ) && (
                            <option
                              value={this.state.selectedPurchaseRequestId}
                            >
                              {this.state.purchaseOrder?.purchaseOrderNo ||
                                this.state.selectedPurchaseRequestId}
                            </option>
                          )}

                        {(this.state.purchaseRequests || []).map((pr) => (
                          <option key={pr.id} value={String(pr.id)}>
                            {pr.purchaseOrderNo || String(pr.id)}
                          </option>
                        ))}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>

                  <Col md={2}>
                    <FloatingLabel label="Supplier*" className="mb-3">
                      <Form.Select
                        name="supplierId"
                        value={po.supplierId || ""}
                        required
                        className="text-start"
                        onChange={this.handleInputChange}
                      >
                        <option value=""></option>
                        {(this.props.rawmaterialsuppliers || []).map(
                          (supplier) => (
                            <option key={supplier.id} value={supplier.id}>
                              {supplier.name}
                            </option>
                          )
                        )}
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                  <Col md={2}>
                    <FloatingLabel label="Payment Status*" className="mb-3">
                      <Form.Select
                        name="paymentStatusId"
                        value={po.paymentStatusId || ""}
                        required
                        className="text-start"
                        onChange={this.handleInputChange}
                      >
                        <option value=""></option>
                        <option value={1}>Paid</option>
                        <option value={2}>Unpaid</option>
                        <option value={3}>PartiallyPaid</option>
                      </Form.Select>
                    </FloatingLabel>
                  </Col>
                </Row>
                <Row>
                  <Col md="12">
                    <FloatingLabel label="Notes" className="mb-3">
                      <Form.Control
                        type="text"
                        name="description"
                        maxLength={99}
                        value={po.description || ""}
                        placeholder=""
                        autoComplete="off"
                        onChange={this.handleInputChange}
                      />
                    </FloatingLabel>
                  </Col>
                </Row>
              </div>

              {/* Purchase Items  */}
              <div className="my-3 bg-light rounded-3">
                <Row>
                  <Col md={8} className="text-start text-dark my-2">
                    <h4> Purchase Items: </h4>
                  </Col>
                  <Col md={4} className="text-end align-bottom my-2">
                    <Button
                      variant="primary"
                      size="sm"
                      id="addbutton"
                      onClick={this.handleAddItems}
                    >
                      + Add (F8)
                    </Button>
                  </Col>
                </Row>

                {/* Table */}
                <div className="p-3 border d-none d-md-block">
                  <Table
                    bordered
                    hover
                    striped
                    className=" text-start"
                    style={{ fontSize: "12px" }}
                  >
                    <thead className="bg-secondary text-white">
                      <tr className="text-center">
                        <td className="text-center" width="1%"></td>
                        <td className="text-start" width="15%">
                          Product Name
                        </td>
                        <td width="4%">Thickness</td>
                        <td width="4%">Width</td>
                        {this.context.store.businessTypeId ===
                        this.context.BusinessTypes.STEELTRADERS ? (
                          <td width="5%">CoilId</td>
                        ) : (
                          <>
                            <td width="5%">BatchId</td>
                          </>
                        )}
                        <td width="5%">InternalId</td>
                        <td width="5%">HSNCode</td>
                        <td width="8%">Remarks</td>

                        {this.context.store.businessTypeId ===
                          this.context.BusinessTypes.STEELTRADERS && (
                          <td width="4%">Pieces</td>
                        )}
                        <td width="6%">Purchased Qty/Wt</td>
                        {this.context.store.businessTypeId ===
                          this.context.BusinessTypes.STEELTRADERS && (
                          <td width="6%">Local WT</td>
                        )}
                        <td width="6%">Purchase Rate/Unit</td>
                        <td width="4%">Unit</td>
                        <td width="6%">S.Total</td>
                        <td width="10%">Indent Ref</td>
                        <td width="6%">Category</td>
                        <td width="5%">WH</td>
                        <td width="5%">InStock</td>
                        <td width="12%" className="text-center">
                          Options
                        </td>
                      </tr>
                    </thead>

                    <tbody>
                      {items?.map((row, i) => (
                        <tr
                          key={i}
                          className="align-middle text-center"
                          style={{ fontSize: "12px" }}
                        >
                          <td className="text-center">{i + 1}</td>
                          <td className="text-start">
                            <b className="text-black">
                              {this.GetProductInfo(row)}
                            </b>
                          </td>
                          <td className="text-end">
                            {row.thickness !== null &&
                            row.thickness !== undefined
                              ? row.thickness
                              : ""}
                          </td>
                          <td className="text-end">
                            {row.width !== null && row.width !== undefined
                              ? row.width
                              : ""}
                          </td>
                          <td className="text-start">{row.batchId || ""}</td>
                          <td className="text-start">{row.internalId || ""}</td>
                          <td className="text-start">{row.hsnCode || ""}</td>

                          <td className="text-start">{row.remarks || ""}</td>

                          {this.context.store.businessTypeId ===
                            this.context.BusinessTypes.STEELTRADERS && (
                            <td className="text-center">{row.pieces}</td>
                          )}

                          <td>{row.qty}</td>

                          {this.context.store.businessTypeId ===
                            this.context.BusinessTypes.STEELTRADERS && (
                            <td>{row.localWt}</td>
                          )}

                          <td>
                            {this.asNumber(row.rate).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 1,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </td>

                          <td>{row.unit}</td>

                          <td className="text-end">
                            {(this.context.ReturnwithDiscount
                              ? this.context.ReturnwithDiscount(
                                  this.asNumber(row.rate),
                                  this.asNumber(row.qty),
                                  this.asNumber(row.discount)
                                )
                              : this.asNumber(row.rate) *
                                  this.asNumber(row.qty) -
                                (this.asNumber(row.rate) *
                                  this.asNumber(row.qty) *
                                  this.asNumber(row.discount)) /
                                  100
                            ).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </td>
                          {/* Indent Ref cell */}
                          <td className="text-start">
                            {this.GetIndentRefLabel(row.indentItemId || "")}
                          </td>
                          <td className="text-start">
                            {row.categoryName ||
                              this.GetCategoryName(row.categoryId)}
                          </td>
                          <td className="text-center">
                            {this.GetWarehouseName(row.warehouseId)}
                          </td>

                          <td>
                            {row.addedToStock ? (
                              <span className="bg-success text-white p-1">
                                Added
                              </span>
                            ) : (
                              <span className="bg-warning text-dark p-1">
                                Not Added
                              </span>
                            )}
                          </td>

                          <td className="text-center">
                            <Stack direction="horizontal">
                              <OverlayTrigger
                                overlay={<Tooltip>Edit!</Tooltip>}
                              >
                                <Button
                                  size="sm"
                                  className=" "
                                  variant="primary"
                                  onClick={(e) => this.OnEditButtonClick(e, i)}
                                >
                                  Open
                                </Button>
                              </OverlayTrigger>
                              &nbsp;
                              <OverlayTrigger
                                overlay={<Tooltip>Delete!</Tooltip>}
                              >
                                <Button
                                  size="sm"
                                  variant="danger"
                                  onClick={() => this.handleRemoveClick(i)}
                                >
                                  X
                                </Button>
                              </OverlayTrigger>
                            </Stack>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>

                {/* mobile view omitted for brevity (unchanged) */}
                {/* totals & charges ... (unchanged) */}
                <div className="p-3 border">
                  <Table>
                    <tbody>
                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <label className="mb-0 me-2 muted-small">
                            Total (without tax):
                          </label>
                        </td>
                        <td colSpan={3} className="text-end">
                          <h4 className="mb-0">
                            {items.length > 0
                              ? this.asNumber(
                                  this.GetTotalOfPurchaseOrderWithoutTax(items)
                                ).toLocaleString(
                                  this.context.storeSettings.defaultLocale,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 0,
                                    style: "currency",
                                    currency:
                                      this.context.storeSettings
                                        .defaultCurrency,
                                  }
                                )
                              : ""}
                          </h4>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <div className="d-flex justify-content-end gap-2 align-items-center">
                            <label className="mb-0 me-2 muted-small">
                              Purchase Tax (%)
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              name="taxPercentage"
                              value={po.taxPercentage ?? ""}
                              onChange={this.handleInputChange}
                              className="form-control form-control-sm"
                              style={{
                                width: "110px",
                                display: "inline-block",
                              }}
                            />
                          </div>
                        </td>
                        <td colSpan={3} className="text-end">
                          <strong>
                            {this.asNumber(
                              this.GetPurchaseLevelTaxAmount(items)
                            ).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </strong>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <div className="d-flex justify-content-end gap-2 align-items-center">
                            <label className="mb-0 me-2 muted-small">
                              Loading Charges
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              name="loadingCharges"
                              value={po.loadingCharges ?? ""}
                              onChange={this.handleInputChange}
                              className="form-control form-control-sm"
                              style={{
                                width: "110px",
                                display: "inline-block",
                              }}
                            />
                          </div>
                        </td>
                        <td colSpan={3} className="text-end">
                          <strong>
                            {this.asNumber(
                              po.loadingCharges || 0
                            ).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </strong>
                        </td>
                      </tr>

                      <tr>
                        <td colSpan={8}></td>
                        <td colSpan={3} className="text-end align-middle">
                          <div className="d-flex justify-content-end gap-2 align-items-center">
                            <label className="mb-0 me-2 muted-small">
                              Transportation Charges
                            </label>
                            <input
                              type="number"
                              step="0.01"
                              min="0"
                              name="transportationCharges"
                              value={po.transportationCharges ?? ""}
                              onChange={this.handleInputChange}
                              className="form-control form-control-sm"
                              style={{
                                width: "110px",
                                display: "inline-block",
                              }}
                            />
                          </div>
                        </td>
                        <td colSpan={3} className="text-end">
                          <strong>
                            {this.asNumber(
                              po.transportationCharges || 0
                            ).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </strong>
                        </td>
                      </tr>

                      <tr className="bg-light">
                        <td colSpan={10}></td>
                        <td colSpan={3} className="text-end">
                          <h5 className="mb-0">Grand Total</h5>
                        </td>
                        <td className="text-end">
                          <h5 className="mb-0">
                            {this.asNumber(
                              this.GetGrandTotal(items)
                            ).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </h5>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>

                <Row className="text-end">
                  <h6>
                    Information: while Save, Purchase Rate and In-stock will be
                    updated in "RawMaterial Inventory" accordingly!
                  </h6>
                </Row>
              </div>

              {/* Payments Section */}
              <div className="my-3 bg-light rounded-3">
                <Row>
                  <Col md={8} className="text-start text-dark my-2">
                    <h4>Payments:</h4>
                  </Col>
                  <Col md={4} className="text-end align-bottom my-2">
                    <Button
                      variant="primary"
                      size="sm"
                      id="addpayment"
                      onClick={this.OpenAddPayment}
                    >
                      + Add Payment
                    </Button>
                  </Col>
                </Row>

                <div className="p-3 border">
                  <Table
                    bordered
                    hover
                    striped
                    size="sm"
                    className="text-start"
                  >
                    <thead className="bg-secondary text-white">
                      <tr>
                        <th>Date</th>
                        <th>Method</th>
                        <th>Transaction ID</th>
                        <th>Amount</th>
                        <th>Notes</th>
                        <th width="10%">Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(this.state.rawmaterialsPurchaseOrderPayments || []).map(
                        (row, i) => (
                          <tr key={i}>
                            <td>
                              {new Date(row.paymentDate).toLocaleDateString(
                                "en-IN"
                              )}
                            </td>
                            <td>
                              {this.GetPaymentMethodName(row.paymentMethod)}
                            </td>
                            <td>{row.paymentTransactionId}</td>
                            <td className="text-end">
                              {this.asNumber(row.amount).toLocaleString(
                                "en-IN",
                                {
                                  style: "currency",
                                  currency:
                                    this.context.storeSettings.defaultCurrency,
                                }
                              )}
                            </td>
                            <td>{row.notes}</td>
                            <td className="text-center">
                              <Stack direction="horizontal" gap={2}>
                                <Button
                                  size="sm"
                                  variant="warning"
                                  onClick={(e) => this.OnEditPaymentClick(e, i)}
                                >
                                  Edit
                                </Button>
                                <Button
                                  size="sm"
                                  variant="danger"
                                  onClick={() => this.RemovePurchasePayment(i)}
                                >
                                  Delete
                                </Button>
                              </Stack>
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
              {this.state.showPaymentModal && (
                <AddOrEditRawMaterialPurchasePayment
                  onHide={() => this.setState({ showPaymentModal: false })}
                  Type="Add"
                  AddPurchasePayment={this.AddPurchasePayment}
                />
              )}

              {this.state.editPaymentModalShow && (
                <AddOrEditRawMaterialPurchasePayment
                  onHide={() => this.setState({ editPaymentModalShow: false })}
                  Type="Edit"
                  payment={
                    this.state.rawmaterialsPurchaseOrderPayments[
                      this.state.editPaymentRow
                    ]
                  }
                  index={this.state.editPaymentRow}
                  UpdatePurchasePayment={this.UpdatePurchasePayment}
                />
              )}
            </Modal.Body>
            <Modal.Footer className="bg-light">
              <Form.Group>
                <Button variant="primary" size="lg" type="submit">
                  Save
                </Button>
              </Form.Group>

              <Button variant="danger" size="lg" onClick={this.props.onHide}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

/* =======================================================
   AddOrEditRawMaterialPurchaseOrderItem  
======================================================= */
export class AddOrEditRawMaterialPurchaseOrderItem extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      // item row fields
      sku: "",
      itemId: "",
      itemName: "",
      unit: "",
      discount: 0,
      tax: 0,
      warehouseId: props.warehouseId || "",
      pieces: 1,
      hsnCode: "",
      batchId: "", // CoilId
      remarks: "",
      qty: 1,
      rate: 0,
      localWt: undefined,
      mrp: undefined,
      productNames: [],
      reload: true,
      prods: [],
      addedToStock: false,
      indentItemId: "",

      // inventory related fields (to create RawMaterialsInventory inline)
      categoryId: "",
      internalId: "",
      instock: 0,
      pieceCount: 0,
      thickness: 0,
      width: 0,
      length: 0,
      qualityId: "",

      // categories for select (fetched)
      categories: [],

      // flag: user selected an existing product => auto-populate & make fields readonly
      isExisting: false,
    };

    this.asNumber = this.asNumber.bind(this);
  }

  // small helper to parse numbers safely
  asNumber(v) {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(v);
    return Number.isNaN(n) ? 0 : n;
  }

  // Return label for indent reference (supports object or id).
  GetIndentRefLabel = (indent) => {
    if (!indent) return "";

    // If passed an id (string/guid), try to resolve from props.indentItems first
    if (typeof indent === "string" || typeof indent === "number") {
      const found = (this.props.indentItems || []).find(
        (it) => String(it.id) === String(indent)
      );
      if (found) indent = found;
      else return String(indent);
    }

    // indent now expected to be an object
    const name =
      indent.itemName || indent.ItemName || indent.name || indent.Item || "";
    const qtyRaw =
      indent.qty ?? indent.quantity ?? indent.Qty ?? indent.Quantity ?? "";
    const qty =
      qtyRaw !== "" && qtyRaw !== null && !isNaN(Number(qtyRaw))
        ? Number(qtyRaw)
        : "";
    const qtyStr = qty !== "" ? ` x ${qty}` : "";

    // try to include purchaseOrderNo (if provided as prop)
    const poNo = this.props.purchaseOrderNo || "";
    const parts = [];
    if (poNo) parts.push(poNo);
    if (name) parts.push(`${name}${qtyStr}`);
    return parts.join(" — ");
  };

  componentDidMount() {
    if (this.props.Type === "Edit" && this.props.purchaseOrderItem) {
      const pi = this.props.purchaseOrderItem;
      this.setState({
        sku: pi.sku,
        itemId: pi.itemId,
        itemName: pi.itemName,
        unit: pi.unit,
        rate: pi.rate,
        qty: pi.qty,
        localWt: pi.localWt,
        mrp: pi.mrp,
        discount: pi.discount,
        tax: pi.tax,
        pieces: pi.pieces,
        warehouseId: pi.warehouseId,
        hsnCode: pi.hsnCode,
        batchId: pi.batchId,
        qualityId: pi.qualityId || "",
        internalId: pi.internalId || "",
        remarks: pi.remarks,
        addedToStock: !!pi.addedToStock,
        indentItemId: pi.indentItemId || "",
        // inventory-derived fields
        categoryId: pi.categoryId || "",
        instock: pi.instock || 0,
        pieceCount: pi.pieces || 0,
        thickness: pi.thickness || 0,
        width: pi.width || 0,
        length: pi.length || 0,
        // if this row maps to an existing inventory, treat as existing
        isExisting:
          !!pi.itemId &&
          String(pi.itemId) !== "00000000-0000-0000-0000-000000000000",
      });
    }
    if (this.state.warehouseId) this.LoadProductName();
    this.GetRawMaterialCategories();
  }

  // fetch categories so user can set Category inline
  GetRawMaterialCategories = () => {
    try {
      const storeId = this.context.storeId;
      if (!storeId) return;
      fetch(
        `${process.env.REACT_APP_API}Rawmaterials/GetRawMaterialCategories/${storeId}`
      )
        .then((r) => r.json())
        .then((data) => {
          this.setState({ categories: Array.isArray(data) ? data : [] });
        })
        .catch((err) => {
          console.error("GetRawMaterialCategories error", err);
          this.setState({ categories: [] });
        });
    } catch (e) {
      console.error(e);
    }
  };

  GetProductLable = (product) => {
    let result = product.name || "";
    if (product.batchId)
      result +=
        this.context.store.businessTypeId ===
        this.context.BusinessTypes.STEELTRADERS
          ? ` CoilId:${product.batchId}`
          : ` BatchId:${product.batchId}`;

    if (product.remarks) result += ` ${product.remarks}`;

    return result;
  };

  LoadProductName = () => {
    const pd = [];
    const prodsForWh = (this.props.prods || []).filter(
      (f) => String(f.warehouseId) === String(this.state.warehouseId)
    );
    prodsForWh.forEach((r) =>
      pd.push({ value: r.id, label: this.GetProductLable(r) })
    );
    this.setState({
      prods: prodsForWh,
      productNames: pd.sort((a, b) =>
        a.label.toUpperCase() > b.label.toUpperCase() ? 1 : -1
      ),
    });
  };

  GetLabelOfProduct = (id) => {
    const prod = (this.props.prods || []).find(
      (f) => String(f.id) === String(id)
    );
    if (!prod) return "";
    let result = prod.name || "";
    if (prod.batchId) result += ` ${prod.batchId}`;
    if (prod.remarks) result += ` ${prod.remarks}`;
    return result;
  };

  // When user selects an existing product from react-select
  OnProductNameChange = (e) => {
    // e is { value, label } from react-select
    const selectedId = e?.value || "";
    if (!selectedId) {
      // clear selection
      this.setState({
        itemId: "",
        isExisting: false,
      });
      return;
    }

    const prod = (this.props.prods || []).find(
      (f) => String(f.id) === String(selectedId)
    );

    if (!prod) {
      // fallback - store id only
      this.setState({
        itemId: selectedId,
        isExisting: true,
      });
      return;
    }

    // Map product fields into state and mark as existing
    this.setState({
      itemId: String(prod.id),
      itemName: prod.name || "",
      unit: prod.unit || this.state.unit,
      rate: prod.purchasePrice ?? prod.rate ?? this.state.rate,
      categoryId: prod.categoryId || this.state.categoryId,
      hsnCode: prod.hsnCode || prod.HSNCode || this.state.hsnCode,
      batchId: prod.batchId || prod.BatchId || this.state.batchId,
      internalId: prod.internalId || prod.InternalId || this.state.internalId,
      qualityId: prod.qualityId || prod.QualityId || this.state.qualityId,
      remarks: prod.remarks || this.state.remarks,
      thickness: prod.thickness ?? prod.Thickness ?? this.state.thickness,
      width: prod.width ?? prod.Width ?? this.state.width,
      // don't overwrite qty/pieces/instock unless you want to
      // keep other fields stable
      isExisting: true,
    });
  };

  GetProductName = (id) =>
    (this.props.prods || []).find((f) => String(f.id) === String(id))?.name ||
    "";
  GetUnitOfProduct = (id) =>
    (this.props.prods || []).find((f) => String(f.id) === String(id))?.unit ||
    "";
  GetPurchasePriceOfProductId = (id) =>
    (this.props.prods || []).find((f) => String(f.id) === String(id))
      ?.purchasePrice || 0;

  OnIndentRefChange = (e) => {
    const val = e.target.value || "";
    this.setState({ indentItemId: val });
  };

  handleItemsInputChange = (e) => {
    const { name, value } = e.target;
    const numericFields = [
      "discount",
      "tax",
      "qty",
      "rate",
      "pieces",
      "localWt",
      "instock",
      "pieceCount",
      "thickness",
      "width",
      "length",
    ];
    const v = numericFields.includes(name) ? this.asNumber(value) : value;

    if (name === "warehouseId") {
      this.setState({ warehouseId: value }, () => {
        this.LoadProductName();
        // clear previously selected product when warehouse changes
        this.setState({ itemId: "", isExisting: false });
      });
      return;
    }

    // If user types a new itemName, clear any selected itemId so it's clear we'll CREATE a new inventory.
    if (name === "itemName") {
      this.setState({ itemName: v, itemId: "", isExisting: false });
      return;
    }

    // If user edits one of the auto-populated fields while isExisting true, we might allow it only if they clear the selection.
    this.setState({ [name]: v });
  };

  // Create inline inventory if itemId is empty. Returns a Promise resolving to itemId (string)
  EnsureInventoryExists = () => {
    // if existing product selected, just return it
    if (this.state.itemId) return Promise.resolve(this.state.itemId);

    // otherwise create RawMaterialsInventory by calling API
    const inventoryPayload = {
      id: "00000000-0000-0000-0000-000000000000", // Guid.Empty
      name: this.state.itemName,
      storeId: this.context.storeId,
      categoryId: this.state.categoryId || null,
      warehouseId: this.state.warehouseId || null,
      thickness: this.state.thickness || 0,
      width: this.state.width || 0,
      length: this.state.length || 0,
      remarks: this.state.remarks || "",
      internalId: this.state.internalId || "",
      batchId: this.state.batchId || "", // coilId
      hsnCode: this.state.hsnCode || "",
      qualityId: this.state.qualityId || "",
      // pieceCount: this.state.pieceCount || this.state.pieces || 0,
      // localWt: this.state.localWt || 0,
      // instock: this.state.instock || 0,
      unit:
        this.state.unit || this.context.storeSettings.defaultUnit || "piece",
      // purchasePrice: this.state.rate || 0,
      price: this.state.rate || 0,
    };

    // call backend to create inventory — backend now returns created object
    return fetch(
      `${process.env.REACT_APP_API}Rawmaterials/AddOrUpdateRawMaterialsInventory`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(inventoryPayload),
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error("Failed to create inventory");
        return res.json();
      })
      .then((created) => {
        if (!created) throw new Error("No inventory returned from server");
        if (typeof created === "string") {
          try {
            created = JSON.parse(created);
          } catch (e) {
            /* ignore */
          }
        }
        const newId = created.id || created.Id || created.IdString || null;
        return String(newId);
      });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    // validate required fields: itemName (or itemId), warehouseId, qty, rate
    if (!this.state.itemName && !this.state.itemId) {
      Swal.fire({
        title: "Warning",
        text: "Product Name is mandatory!",
        timer: 3000,
      });
      return;
    }
    if (!this.state.warehouseId) {
      Swal.fire({ title: "Warning", text: "Select Warehouse!", timer: 3000 });
      return;
    }

    // Ensure inventory exists (create if necessary), then add item to PO
    this.EnsureInventoryExists()
      .then((itemId) => {
        const payload = {
          sku: this.state.sku,
          itemId: itemId,
          itemName: this.state.itemName,
          unit: this.state.unit,
          rate: this.state.rate,
          qty: this.state.qty,
          localWt: this.state.localWt,
          mrp: this.state.mrp,
          discount: this.state.discount,
          tax: this.state.tax,
          warehouseId: this.state.warehouseId,
          hsnCode: this.state.hsnCode,
          batchId: this.state.batchId,
          pieces: this.state.pieces,
          remarks: this.state.remarks,
          indentItemId: this.state.indentItemId || null,
          // include inventory-level fields so backend stores them in PO item if needed
          categoryId: this.state.categoryId || null,
          internalId: this.state.internalId || "",
          instock: this.state.instock || 0,
          thickness: this.state.thickness || 0,
          width: this.state.width || 0,
          length: this.state.length || 0,
          qualityId: this.state.qualityId || "",
        };

        if (this.props.Type === "Add") this.props.AddPurchaseItem?.(payload);
        else this.props.UpdatePurchaseItem?.(payload, this.props.Index);

        this.props.onHide?.();
      })
      .catch((err) => {
        console.error("EnsureInventoryExists error", err);
        Swal.fire(
          "Error",
          "Failed to create product. It could be the same product is already in the Inventory. Try again.",
          "error"
        );
      });
  };

  render() {
    const indentItems = this.props.indentItems || [];
    const categories = this.state.categories || [];
    const isReadOnly = this.state.addedToStock === true;
    const isExisting = this.state.isExisting === true;

    return (
      <div className="container ">
        <Modal
          {...this.props}
          size="xl"
          centered
          show
          backdrop="static"
          keyboard={false}
        >
          <Form onSubmit={this.handleSubmit}>
            <Modal.Header closeButton className="bg-warning">
              <Modal.Title>
                {this.props.Type === "Edit"
                  ? "Edit Purchase Item"
                  : "Add Purchase Item"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Row className="mb-2">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Warehouse *</Form.Label>
                    <Form.Select
                      name="warehouseId"
                      value={this.state.warehouseId}
                      required
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    >
                      <option value=""></option>
                      {(this.props.rawmaterialwarehouse || []).map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Indent Ref</Form.Label>
                    <Form.Select
                      name="indentItemId"
                      disabled={isReadOnly}
                      value={this.state.indentItemId || ""}
                      onChange={this.OnIndentRefChange}
                    >
                      <option value="">-- none --</option>
                      {this.state.indentItemId &&
                        !indentItems.find(
                          (it) =>
                            String(it.id) === String(this.state.indentItemId)
                        ) && (
                          <option value={this.state.indentItemId}>
                            {this.GetIndentRefLabel({
                              id: this.state.indentItemId,
                              itemName: this.state.itemName,
                              qty: this.state.qty,
                            })}
                          </option>
                        )}
                      {indentItems.map((it) => (
                        <option key={it.id} value={it.id}>
                          {this.GetIndentRefLabel(it)}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="m-3 p-3 border CornersRounded">
                <Col md={5}>
                  <Form.Group>
                    <Form.Label>
                      Select existing Rawmaterial (optional)
                    </Form.Label>
                    <div style={{ display: "flex", gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <Select
                          name="itemId"
                          isDisabled={isReadOnly}
                          value={{
                            value: this.state.itemId,
                            label: this.GetLabelOfProduct(this.state.itemId),
                          }}
                          onChange={this.OnProductNameChange}
                          options={this.state.productNames}
                          placeholder="Select existing raw material (or leave empty to create new)"
                        />
                        <div className="small text-muted mt-1">
                          Selecting an existing item auto-fills category, spec &
                          other fields and makes them read-only.
                        </div>
                      </div>
                    </div>
                  </Form.Group>
                </Col>

                <Col md={5}>
                  <Form.Group>
                    <Form.Label>
                      Or enter NEW Rawmaterial name{" "}
                      <small className="text-muted">
                        (creates new inventory)
                      </small>
                    </Form.Label>
                    <Form.Control
                      name="itemName"
                      disabled={isReadOnly || isExisting}
                      value={this.state.itemName}
                      onChange={this.handleItemsInputChange}
                    />
                    <div className="small text-muted mt-1">
                      Type a new name to create a new inventory item. Choosing
                      an existing item disables this field.
                    </div>
                  </Form.Group>
                </Col>
                <Col md={1}>
                  <FloatingLabel label="Thickness" className="mb-1">
                    <Form.Control
                      type="number"
                      name="thickness"
                      value={this.state.thickness}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={1}>
                  <FloatingLabel label="Width" className="mb-1">
                    <Form.Control
                      type="number"
                      name="width"
                      value={this.state.width}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
              </Row>

              {/* If user didn't select existing product, allow entering raw material fields to create new inventory inline */}
              <Row className="mb-2">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>Category</Form.Label>
                    <Form.Select
                      name="categoryId"
                      required
                      value={this.state.categoryId}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    >
                      <option value=""></option>
                      {categories.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <FloatingLabel label="CoilId / BatchId" className="mb-1">
                    <Form.Control
                      name="batchId"
                      required
                      value={this.state.batchId}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="InternalId" className="mb-1">
                    <Form.Control
                      name="internalId"
                      disabled={isReadOnly || isExisting}
                      value={this.state.internalId}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="HSN Code" className="mb-1">
                    <Form.Control
                      name="hsnCode"
                      value={this.state.hsnCode}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="Quality Id" className="mb-1">
                    <Form.Control
                      name="qualityId"
                      value={this.state.qualityId}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
              </Row>

              <Row className="mb-2">
                <Col md={2}>
                  <FloatingLabel label="Pieces" className="mb-1">
                    <Form.Control
                      type="number"
                      name="pieces"
                      disabled={isReadOnly}
                      value={this.state.pieces}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="Purchased Qty/Wt" className="mb-1">
                    <Form.Control
                      type="number"
                      name="qty"
                      value={this.state.qty}
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>

                <Col md={2}>
                  <FloatingLabel label="Local Wt" className="mb-1">
                    <Form.Control
                      type="number"
                      name="localWt"
                      value={this.state.localWt ?? ""}
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="Unit" className="mb-1">
                    <Form.Select
                      name="unit"
                      required
                      value={this.state.unit}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    >
                      <option value=""></option>
                      <option value="piece">piece</option>
                      <option value="gram">gram</option>
                      <option value="kg">kg</option>
                      <option value="ton">ton</option>
                      <option value="ml">ml</option>
                      <option value="liter">liter</option>
                      <option value="meter">meter</option>
                    </Form.Select>
                  </FloatingLabel>
                </Col>
                <Col md={2}>
                  <FloatingLabel label="Purchase Rate" className="mb-1">
                    <Form.Control
                      type="number"
                      name="rate"
                      value={this.state.rate}
                      disabled={isReadOnly}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FloatingLabel label="Remarks" className="mb-1">
                    <Form.Control
                      name="remarks"
                      value={this.state.remarks}
                      disabled={isReadOnly || isExisting}
                      onChange={this.handleItemsInputChange}
                    />
                  </FloatingLabel>
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="primary" type="submit">
                Save
              </Button>
              <Button variant="danger" onClick={() => this.props.onHide?.()}>
                Close
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </div>
    );
  }
}

export default class AddOrEditRawMaterialPurchasePayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      payment: {
        id: props.payment?.id || "",
        paymentDate: props.payment?.paymentDate
          ? new Date(props.payment.paymentDate).toISOString().split("T")[0]
          : new Date().toISOString().split("T")[0],
        paymentTransactionId: props.payment?.paymentTransactionId || "",
        paymentMethod: props.payment?.paymentMethod || 1,
        amount: props.payment?.amount || 0,
        notes: props.payment?.notes || "",
      },
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      payment: { ...prev.payment, [name]: value },
    }));
  };

  handleSave = () => {
    const { Type, AddPurchasePayment, UpdatePurchasePayment, index } =
      this.props;
    const { payment } = this.state;

    if (!payment.amount || Number(payment.amount) <= 0) {
      Swal.fire("Validation", "Please enter a valid amount", "warning");
      return;
    }

    const payload = {
      ...payment,
      amount: Number(payment.amount),
      paymentDate: new Date(payment.paymentDate),
    };

    if (Type === "Edit") {
      UpdatePurchasePayment && UpdatePurchasePayment(payload, index);
    } else {
      AddPurchasePayment && AddPurchasePayment(payload);
    }
  };

  render() {
    const { onHide, Type } = this.props;
    const { payment } = this.state;

    return (
      <Modal show onHide={onHide} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {Type === "Edit" ? "Edit Payment" : "Add Payment"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>Payment Date</Form.Label>
              <Form.Control
                type="date"
                name="paymentDate"
                value={payment.paymentDate}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Method</Form.Label>
              <Form.Select
                name="paymentMethod"
                value={payment.paymentMethod}
                onChange={this.handleChange}
              >
                <option value={1}>Cash</option>
                <option value={2}>Bank Transfer</option>
                <option value={3}>Cheque</option>
                <option value={4}>UPI</option>
                <option value={9}>Other</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Transaction Id</Form.Label>
              <Form.Control
                name="paymentTransactionId"
                value={payment.paymentTransactionId}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Amount</Form.Label>
              <Form.Control
                type="number"
                min="0"
                step="0.01"
                name="amount"
                value={payment.amount}
                onChange={this.handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                name="notes"
                value={payment.notes}
                onChange={this.handleChange}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" onClick={this.handleSave}>
            {Type === "Edit" ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
